'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Store = {
  init: function init() {
    JSONStorage.clear();
    var collections = { appointments: {}, interviewRuns: {}, secureMessages: {}, interviews: {}, profiles: {}, settings: {}, interviewTimes: {}, privacyPolicy: {}, graphData: { sessionOnly: true } };
    WL.JSONStore.init(collections, {}).then(function () {}).fail(function (errorObject) {
      console.log(errorObject.msg);
    });
  },

  clearAll: function clearAll() {
    JSONStorage.clear();
  },

  save: function save(interviewRun) {
    return WL.JSONStore.get('interviewRuns').add(interviewRun);
  },

  remove: function remove(interviewRun) {
    return WL.JSONStore.get('interviewRuns').remove(interviewRun);
  },

  getAll: function getAll() {
    return WL.JSONStore.get('interviewRuns').find({ patientId: Auth.patientId() });
  },

  saveMessage: function saveMessage(message) {
    return WL.JSONStore.get('secureMessages').add({ patient_id: Auth.patientId(), message_json: message });
  },

  getMessages: function getMessages() {
    return WL.JSONStore.get('secureMessages').find({ patient_id: Auth.patientId() });
  },

  clearMessages: function clearMessages() {
    return WL.JSONStore.get('secureMessages').remove({ patient_id: Auth.patientId() });
  },

  saveAppointment: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apptJson) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', WL.JSONStore.get('appointments').add(apptJson));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function saveAppointment(_x) {
      return _ref.apply(this, arguments);
    }

    return saveAppointment;
  }(),
  getAppointments: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', WL.JSONStore.get('appointments').find({ patient_id: Auth.patientId() }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function getAppointments() {
      return _ref2.apply(this, arguments);
    }

    return getAppointments;
  }(),
  getAppointmentsForAllPatients: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', WL.JSONStore.get('appointments').findAll());

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getAppointmentsForAllPatients() {
      return _ref3.apply(this, arguments);
    }

    return getAppointmentsForAllPatients;
  }(),
  clearAppointments: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', WL.JSONStore.get('appointments').remove({ patient_id: Auth.patientId() }));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function clearAppointments() {
      return _ref4.apply(this, arguments);
    }

    return clearAppointments;
  }(),
  markAppointmentComplete: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
      var coll, records;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              coll = WL.JSONStore.get('appointments');
              _context5.next = 3;
              return coll.find({ patient_id: Auth.patientId(), id: "" + id });

            case 3:
              records = _context5.sent;

              if (records != null && records.length > 0) {
                records[0].json.completed = true;
                coll.replace(records[0]);
              }

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function markAppointmentComplete(_x2) {
      return _ref5.apply(this, arguments);
    }

    return markAppointmentComplete;
  }(),
  updateAppointment: function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(record) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              JSONStore.get('appointments').replace(record);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function updateAppointment(_x3) {
      return _ref6.apply(this, arguments);
    }

    return updateAppointment;
  }(),


  saveInterviews: function saveInterviews(interviewJson) {
    var coll = WL.JSONStore.get('interviews');
    coll.remove({ patientId: Auth.patientId() });

    return coll.add(interviewJson);
  },

  loadInterviews: function loadInterviews() {
    return WL.JSONStore.get('interviews').find({ patientId: Auth.patientId() });
  },

  saveProfiles: function saveProfiles(profileJson) {
    var coll = WL.JSONStore.get('profiles');
    coll.remove({ patientId: Auth.patientId() });
    return coll.add(profileJson);
  },

  savePrivacyPolicy: function savePrivacyPolicy(policy) {
    var store = WL.JSONStore.get('privacyPolicy');
    store._removeAll();
    store.add(policy);
  },
  getPrivacyPolicy: function getPrivacyPolicy() {
    return WL.JSONStore.get('privacyPolicy').findAll();
  },

  loadCurrentProfile: function loadCurrentProfile() {
    return this.loadPatientProfile(Auth.patientId());
  },

  loadPatientProfile: function loadPatientProfile(patientId) {
    return WL.JSONStore.get('profiles').find({ patientId: patientId });
  },

  getPatientList: function getPatientList() {
    var patientList = [];
    Store.getAllSettings().then(function (settings) {
      for (var i = 0; i < settings.length; i++) {
        if (settings[i].json.patientId) {
          patientList.push(settings[i]);
        }
      }
    });
    return patientList;
  },

  loadProfiles: function loadProfiles() {
    return WL.JSONStore.get('profiles').find({ patientId: Auth.patientId() });
  },

  getSettings: function getSettings() {
    return WL.JSONStore.get('settings').find({ patientId: Auth.patientId() });
  },

  findSettings: function findSettings(id) {
    return WL.JSONStore.get('settings').find({ patientId: id });
  },

  deleteSettings: function deleteSettings(object) {
    return WL.JSONStore.get('settings').remove(object);
  },

  getAllSettings: function getAllSettings() {
    return WL.JSONStore.get('settings').findAll();
  },

  saveSettings: function saveSettings(object) {
    if (typeof object['_id'] == 'undefined') return WL.JSONStore.get('settings').add(object);else return WL.JSONStore.get('settings').replace(object);
  },

  saveInterviewTimes: function saveInterviewTimes(timesJson) {
    var coll = WL.JSONStore.get('interviewTimes');
    coll.remove({ patientId: timesJson.patientId });
    return coll.add(timesJson);
  },

  loadInterviewTimes: function loadInterviewTimes() {
    return WL.JSONStore.get('interviewTimes').find({ patientId: Auth.patientId() });
  },

  saveGraphData: function saveGraphData(graphData) {
    //console.log(graphData);
    var coll = WL.JSONStore.get('graphData');
    coll.remove({ patient_id: graphData.patient_id, measurement_id: graphData.measurement_id, date_range: graphData.dateRange });
    return coll.add(graphData);
  },

  loadGraphData: function loadGraphData(measurementId, dateRange) {
    return WL.JSONStore.get('graphData').find({ patient_id: parseInt(Auth.patientId()), measurement_id: measurementId, date_range: dateRange });
  },

  clearGraphData: function clearGraphData(measurementId) {
    var coll = WL.JSONStore.get('graphData');
    coll.remove({ patient_id: parseInt(Auth.patientId()), measurement_id: measurementId });
  },

  clearAllGraphData: function clearAllGraphData() {
    return WL.JSONStore.get('graphData').remove({});
  },

  getLastSyncDate: function getLastSyncDate() {
    var syncDate;
    Store.getSettings().then(function (settings) {
      if (settings[0] != null) {
        syncDate = settings[0].json.lastSyncDate;
      } else {
        syncDate = null;
      }
    });
    return syncDate;
  },

  setLastSyncDate: function setLastSyncDate() {
    Store.getSettings().then(function (settings) {
      var new_date = new Date();
      settings[0].json.lastSyncDate = new_date.toISOString();
      Store.saveSettings(settings[0]);
      return new_date;
    });
  },

  getVolume: function getVolume() {
    var volume = "up";
    Store.getSettings().then(function (settings) {
      if (settings[0] != null) {
        volume = settings[0].json.volume;
        if (!volume) {
          volume = "up";
        }
      } else {
        volume = 'up';
      }
    });
    return volume;
  },

  setVolume: function setVolume(newVol) {
    Store.getSettings().then(function (settings) {
      settings[0].json.volume = newVol;
      Store.saveSettings(settings[0]);
    });
  },

  getRememberMe: function getRememberMe() {
    var rememberMe;
    Store.getSettings().then(function (settings) {
      if (settings[0] != null && settings[0].json) {
        rememberMe = settings[0].json.rememberMe;
      } else {
        rememberMe = null;
      }
    });
    return rememberMe;
  },

  setRememberMe: function setRememberMe(val) {
    Store.getSettings().then(function (settings) {
      if (settings[0] != null && settings[0].json) {
        settings[0].json.rememberMe = val;
        Store.saveSettings(settings[0]);
      }
    });
  },

  clearRememberMe: function clearRememberMe(id) {
    Store.findSettings(id).then(function (settings) {
      if (settings[0] != null && settings[0].json) {
        settings[0].json.rememberMe = null;
        Store.saveSettings(settings[0]);
      }
    });
  },

  getDeviceUUID: function getDeviceUUID() {
    var uuid;
    if (inBrowser) {
      uuid = JSONStorage.read("device.uuid", false);
      if (uuid == null) {
        uuid = UUID.generate();
        JSONStorage.write("device.uuid", uuid, false);
      }
    } else {
      uuid = "" + window.device.uuid;
    }
    return uuid;
  },

  checkRememberMe: function checkRememberMe() {

    var patientList = Store.getPatientList();

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = patientList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pi = _step.value;

        if (pi.json.rememberMe) {
          return pi.json.rememberMe;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  },

  clearAllRememberMe: function clearAllRememberMe() {

    var patientList = Store.getPatientList();

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = patientList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var pi = _step2.value;

        if (pi.json.rememberMe) {
          pi.json.rememberMe = null;
          Store.saveSettings(pi);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

};